/* eslint-disable */
import * as helpers from './helpers/index.js';

export function install(Vue, options) {
	if (install.installed) return;
  install.installed = true;
  Object.keys(helpers).forEach(key => {
    if (!Vue.prototype[`$${key}`]) {
      Vue.prototype[`$${key}`] = helpers[key];
    } else {
      const newKey = `${options.prefix}${key.charAt(0).toUpperCase() + key.slice(1)}`;
      if (!Vue.prototype[`$${newKey}`]) {
        Vue.prototype[`$${newKey}`] = helpers[key];
      } else {
        console.warn(`[playposit-utilities] Failed to attach helper function "${key}" to Vue.prototype.$${key} because a value with that name already exists.`);
      }
    }
  });
}

export * from './helpers/index.js';